module.exports = __webpack_public_path__ + "static/banner-416b0eaf000c12774023c796e14fe169.jpg";